module.exports = __webpack_public_path__ + "img/img-154.bd66b78c.png";